<template>
  <div class="coupon-detail-page">
    <a-spin :spinning="loading">
      <a-card :bordered="false">
        <template slot="title">
          <page-back-title title="优惠券详情" />
        </template>
        <coupon-form v-model="form" disabled>
          <template v-slot:footer>
            <a-button @click="$router.back()">返回</a-button>
          </template>
        </coupon-form>
      </a-card>
    </a-spin>
  </div>
</template>

<script>
import CouponForm, { createDefaultCouponForm, mapDetailToCouponForm } from './components/CouponForm.vue'
import PageBackTitle from './components/PageBackTitle.vue'

export default {
  name: 'CouponDetail',
  components: {
    CouponForm,
    PageBackTitle
  },
  data () {
    return {
      loading: false,
      form: createDefaultCouponForm()
    }
  },
  created () {
    this.fetchDetail()
  },
  methods: {
    fetchDetail () {
      const couponCode = this.$route.query.couponCode
      if (!couponCode) {
        this.$message.error('缺少优惠券ID')
        return
      }
      this.loading = true
      this.getHttpServices()
        .getNewServeService()
        .post(`/coupon/detail/${couponCode}`)
        .then(res => {
          this.form = mapDetailToCouponForm(res || {})
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '获取详情失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
